import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  fetchToursDetail,
  ApproveRejectTour,
} from "../../redux/moderation/tours/actions";
import history from "../../history";
import InputText from "../InputText";
import config from "../../utils/config";
import CrossIcon from "../../assets/images/close_icon.svg";
import TickIcon from "../../assets/images/tick_icon.svg";
import {
  ExperienceGalleryModeration,
  fetchExperienceDetail,
} from "../../redux/moderation/experience/actions";
import Slider from "react-slick";
import get from "lodash/get";

var settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export default function ExperiecePersonalInfromation(props) {
  const _ = { get };
  const location = useHistory();
  const dispatch = useDispatch();
  const { elements } = useSelector((state) => state.Elements);
  const { usertype } = useSelector((state) => state.Auth);
  const { toursDetails } = useSelector((state) => state.Tours);
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectionReasonToggle, setRejectionReasonToggle] = useState(false);

  const [rejectImage, setRejectImage] = useState(false);
  const [rejectionType, setRejectionType] = useState("");
  const [rejectionId, setRejectionId] = useState("");
  const [previewImage, setPreviewImage] = useState(false);
  const [imageDetail, setImageDetail] = useState(null);
  const [previewGalleryImage, setPreviewGalleryImage] = useState(false);
  const [imageGalleryDetails, setImageGalleryDetails] = useState(null);

  useEffect(() => {
    if (
      toursDetails === null ||
      toursDetails._id !== location.location.search.split("=")[1]
    )
      dispatch(fetchToursDetail(location.location.search.split("=")[1]));
  }, []);
  const handleApprove = () => {
    let obj = {
      wanderlustId: toursDetails._id,
      status: "APPROVED",
    };
    dispatch(ApproveRejectTour(obj));
  };
  const handleReject = () => {
    let obj = {
      wanderlustId: toursDetails._id,
      status: "REJECTED",
      rejectionReason: rejectionReason,
    };
    setRejectionReason("");
    dispatch(ApproveRejectTour(obj));
  };

  const handleGoBack = () => {
    history.push("/moderation/experiences");
  };

  const handleApproveGalleryModeration = (item, type) => {
    let obj = {
      status: "APPROVED",
      category: "EXPERIENCE",
      assetId: item,
      categoryId: toursDetails._id,
    };
    let obj2 = {
      status: "APPROVED",
      category: "EXPERIENCE",
      categoryId: toursDetails._id,
      groupId: item,
    };
    if (type === "All") {
      dispatch(ExperienceGalleryModeration(obj2, handleApproveCallBack));
    } else {
      dispatch(ExperienceGalleryModeration(obj, handleApproveCallBack));
    }
  };

  const handleRejectGalleryModeration = (item) => {
    let obj = {
      status: "REJECTED",
      category: "EXPERIENCE",
      assetId: rejectionId,
      categoryId: toursDetails._id,
    };
    let obj2 = {
      status: "REJECTED",
      category: "EXPERIENCE",
      categoryId: toursDetails._id,
      groupId: rejectionId,
    };
    setRejectionReason("");
    if (rejectionType === "All") {
      dispatch(ExperienceGalleryModeration(obj2, handleRejectCallBack));
    } else {
      dispatch(ExperienceGalleryModeration(obj, handleRejectCallBack));
    }
  };

  const handleRejectCallBack = () => {
    setRejectionReasonToggle(!rejectionReasonToggle);
    dispatch(fetchToursDetail(location.location.search.split("=")[1]));
  };
  const handleApproveCallBack = () => {
    dispatch(fetchToursDetail(location.location.search.split("=")[1]));
  };

  const handlePreviewImages = (e, image) => {
    setPreviewImage(!previewImage);
    setImageDetail(image);
  };

  const handlePreviewGalleryImages = (e, image) => {
    setPreviewGalleryImage(!previewGalleryImage);
    setImageGalleryDetails(image);
  };

  return (
    <React.Fragment>
      <div className="hideSearch mt-4">
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={`${toursDetails &&
                  toursDetails.name} by ${toursDetails &&
                  toursDetails.partnerId &&
                  toursDetails.partnerId.name}`}
                iconClass={"hideexcel"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            <CardBody>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.experiencePersonalInfo.partnerDeatilHeadingElement",
                        "Partner Detail"
                      )}
                    </span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.nameLabel",
                      "Name"
                    )}
                    titleName={
                      toursDetails &&
                      toursDetails.partnerId &&
                      toursDetails.partnerId.name
                        ? toursDetails.partnerId.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.emailLabel",
                      "Email"
                    )}
                    titleName={
                      toursDetails &&
                      toursDetails.partnerId &&
                      toursDetails.partnerId.email
                        ? toursDetails.partnerId.email
                        : "N/A"
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "euToursElement.experiencePersonalInfo.experienceDetailHeadingElement",
                        "Experience Detail"
                      )}
                    </span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.nameLabel",
                      "Name"
                    )}
                    titleName={
                      toursDetails && toursDetails.name
                        ? toursDetails.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.startLocationLabel",
                      "Start Location"
                    )}
                    titleName={
                      toursDetails &&
                      toursDetails.startPoint &&
                      toursDetails.startPoint.name
                        ? toursDetails.startPoint.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.startLocationLatitudeLabel",
                      "Start Location Latitude"
                    )}
                    titleName={
                      toursDetails &&
                      toursDetails.startPoint &&
                      toursDetails.startPoint.latitude
                        ? toursDetails.startPoint.latitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.startLocationLongitudeLabel",
                      "Start Location Longitude"
                    )}
                    titleName={
                      toursDetails &&
                      toursDetails.startPoint &&
                      toursDetails.startPoint.longitude
                        ? toursDetails.startPoint.longitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.endLocationLabel",
                      "End Location"
                    )}
                    titleName={
                      toursDetails &&
                      toursDetails.endPoint &&
                      toursDetails.endPoint.name
                        ? toursDetails.endPoint.name
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.endLocationLatitude",
                      "End Location Latitude"
                    )}
                    titleName={
                      toursDetails &&
                      toursDetails.endPoint &&
                      toursDetails.endPoint.latitude
                        ? toursDetails.endPoint.latitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.endLocationLongitude",
                      "End Location Longitude"
                    )}
                    titleName={
                      toursDetails &&
                      toursDetails.endPoint &&
                      toursDetails.endPoint.longitude
                        ? toursDetails.endPoint.longitude
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.startDateLabel",
                      "Start Date"
                    )}
                    titleName={
                      toursDetails && toursDetails.startDate
                        ? toursDetails.startDate
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.endDateLabel",
                      "End Date"
                    )}
                    titleName={
                      toursDetails && toursDetails.endDate
                        ? toursDetails.endDate
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.regionLabel",
                      "Region"
                    )}
                    titleName={
                      toursDetails && toursDetails.region
                        ? toursDetails.region
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.countryLabel",
                      "Country"
                    )}
                    titleName={
                      toursDetails && toursDetails.country
                        ? toursDetails.country
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.distanceCoveredLabel",
                      "Estimated Distance Covered (KM)"
                    )}
                    titleName={
                      toursDetails && toursDetails.totalDistance
                        ? toursDetails.totalDistance
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={12} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.descriptionLabel",
                      "Description"
                    )}
                    description={
                      toursDetails && toursDetails.description
                        ? toursDetails.description
                        : "N/A"
                    }
                  />
                </Col>
              </Row>

              <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                <div className="image_heading">
                  {_.get(
                    elements,
                    "euToursElement.experiencePersonalInfo.thumbnailImageLabel",
                    "Experience Landing Page - Thumbnail - Common - (160 x 190 px) (Tap on the image to preview )"
                  )}
                </div>
                {toursDetails &&
                toursDetails.moderateImage &&
                toursDetails.moderateImage.thumbnailImage &&
                toursDetails.moderateImage.thumbnailImage.images &&
                toursDetails.moderateImage.thumbnailImage.images.srcPath ? (
                  <img
                    className="image_bikeman"
                    src={`${config.imageBaseUrl}/${toursDetails &&
                      toursDetails.moderateImage &&
                      toursDetails.moderateImage.thumbnailImage &&
                      toursDetails.moderateImage.thumbnailImage.images &&
                      toursDetails.moderateImage.thumbnailImage.images.srcPath}
                    `}
                    onClick={(e) =>
                      handlePreviewImages(
                        e,
                        toursDetails.moderateImage &&
                          toursDetails.moderateImage.thumbnailImage &&
                          toursDetails.moderateImage.thumbnailImage.images &&
                          toursDetails.moderateImage.thumbnailImage.images
                      )
                    }
                    alt="img"
                  />
                ) : (
                  "N/A"
                )}
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") && (
                    <div className="d-flex justify-content-center align-items-center mt-n5">
                      {toursDetails &&
                        toursDetails.moderateImage &&
                        toursDetails.moderateImage.thumbnailImage &&
                        toursDetails.moderateImage.thumbnailImage.images &&
                        toursDetails.moderateImage.thumbnailImage.images &&
                        (toursDetails.moderateImage.thumbnailImage.images
                          .moderationStatus === "PENDING" ||
                          toursDetails.moderateImage.thumbnailImage.images
                            .moderationStatus === "APPROVED") && (
                          <img
                            className="image_gallery"
                            alt="close"
                            src={CrossIcon}
                            onClick={() => {
                              setRejectImage(true);
                              setRejectionReasonToggle(!rejectionReasonToggle);
                              setRejectionId(
                                toursDetails &&
                                  toursDetails.moderateImage &&
                                  toursDetails.moderateImage.thumbnailImage &&
                                  toursDetails.moderateImage.thumbnailImage
                                    .images &&
                                  toursDetails.moderateImage.thumbnailImage
                                    .images._id
                              );
                            }}
                          />
                        )}
                      {toursDetails &&
                        toursDetails.moderateImage &&
                        toursDetails.moderateImage.thumbnailImage &&
                        toursDetails.moderateImage.thumbnailImage.images &&
                        toursDetails.moderateImage.thumbnailImage.images &&
                        (toursDetails.moderateImage.thumbnailImage.images
                          .moderationStatus === "PENDING" ||
                          toursDetails.moderateImage.thumbnailImage.images
                            .moderationStatus === "REJECTED") && (
                          <img
                            className="image_gallery"
                            alt="tick"
                            src={TickIcon}
                            onClick={() =>
                              handleApproveGalleryModeration(
                                toursDetails &&
                                  toursDetails.moderateImage &&
                                  toursDetails.moderateImage.thumbnailImage &&
                                  toursDetails.moderateImage.thumbnailImage
                                    .images &&
                                  toursDetails.moderateImage.thumbnailImage
                                    .images._id
                              )
                            }
                          />
                        )}
                    </div>
                  )}
              </Col>
              <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                <div className="image_heading">
                  Partner Detail Page - Experience Listing Thumbnail - Common
                  (360 x 310 px)(Tap on the image to preview )
                </div>
                {toursDetails &&
                toursDetails.moderateImage &&
                toursDetails.moderateImage.thumbnailPartnerImage &&
                toursDetails.moderateImage.thumbnailPartnerImage.images &&
                toursDetails.moderateImage.thumbnailPartnerImage.images
                  .srcPath ? (
                  <img
                    className="image_bikeman"
                    src={`${config.imageBaseUrl}/${toursDetails &&
                      toursDetails.moderateImage &&
                      toursDetails.moderateImage.thumbnailPartnerImage &&
                      toursDetails.moderateImage.thumbnailPartnerImage.images &&
                      toursDetails.moderateImage.thumbnailPartnerImage.images
                        .srcPath}
                    `}
                    onClick={(e) =>
                      handlePreviewImages(
                        e,
                        toursDetails.moderateImage &&
                          toursDetails.moderateImage.thumbnailPartnerImage &&
                          toursDetails.moderateImage.thumbnailPartnerImage
                            .images &&
                          toursDetails.moderateImage.thumbnailPartnerImage
                            .images
                      )
                    }
                    alt="img"
                  />
                ) : (
                  "N/A"
                )}
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") && (
                    <div className="d-flex justify-content-center align-items-center mt-n5">
                      {toursDetails &&
                        toursDetails.moderateImage &&
                        toursDetails.moderateImage.thumbnailPartnerImage &&
                        toursDetails.moderateImage.thumbnailPartnerImage
                          .images &&
                        (toursDetails.moderateImage.thumbnailPartnerImage.images
                          .moderationStatus === "PENDING" ||
                          toursDetails.moderateImage.thumbnailPartnerImage
                            .images.moderationStatus === "APPROVED") && (
                          <img
                            className="image_gallery"
                            alt="close"
                            src={CrossIcon}
                            onClick={() => {
                              setRejectImage(true);
                              setRejectionReasonToggle(!rejectionReasonToggle);
                              setRejectionId(
                                toursDetails &&
                                  toursDetails.moderateImage &&
                                  toursDetails.moderateImage
                                    .thumbnailPartnerImage &&
                                  toursDetails.moderateImage
                                    .thumbnailPartnerImage.images &&
                                  toursDetails.moderateImage
                                    .thumbnailPartnerImage.images._id
                              );
                            }}
                          />
                        )}
                      {toursDetails &&
                        toursDetails.moderateImage &&
                        toursDetails.moderateImage.thumbnailPartnerImage &&
                        toursDetails.moderateImage.thumbnailPartnerImage
                          .images &&
                        (toursDetails.moderateImage.thumbnailPartnerImage.images
                          .moderationStatus === "PENDING" ||
                          toursDetails.moderateImage.thumbnailPartnerImage
                            .images.moderationStatus === "REJECTED") && (
                          <img
                            className="image_gallery"
                            alt="tick"
                            src={TickIcon}
                            onClick={() =>
                              handleApproveGalleryModeration(
                                toursDetails &&
                                  toursDetails.moderateImage &&
                                  toursDetails.moderateImage
                                    .thumbnailPartnerImage &&
                                  toursDetails.moderateImage
                                    .thumbnailPartnerImage.images &&
                                  toursDetails.moderateImage
                                    .thumbnailPartnerImage.images._id
                              )
                            }
                          />
                        )}
                    </div>
                  )}
              </Col>
              <Row>
                <Col md={12} className="mt-4 mb-2">
                  <div className="image_heading">
                    {_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.galleryImageLabel",
                      "Gallery Images Common (Tap on the image to preview )"
                    )}
                  </div>
                </Col>

                {toursDetails &&
                toursDetails.moderateImage &&
                toursDetails.moderateImage.gallery &&
                toursDetails.moderateImage.gallery.images ? (
                  toursDetails.moderateImage.gallery.images.map((item) => (
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                      <div>
                        <img
                          className="image_bikeman"
                          src={`${config.imageBaseUrl}/${item.srcPath}`}
                          onClick={(e) =>
                            handlePreviewGalleryImages(
                              e,
                              toursDetails &&
                                toursDetails.moderateImage &&
                                toursDetails.moderateImage.gallery &&
                                toursDetails.moderateImage.gallery.images
                            )
                          }
                          alt="img"
                        />
                        {usertype &&
                          (usertype === "EU Tours Admin" ||
                            usertype === "Admin") && (
                            <div className="d-flex justify-content-center mt-n5">
                              {(item.moderationStatus === "PENDING" ||
                                item.moderationStatus === "APPROVED") && (
                                <img
                                  className="image_gallery"
                                  alt="close"
                                  src={CrossIcon}
                                  onClick={() => {
                                    setRejectImage(true);
                                    setRejectionReasonToggle(
                                      !rejectionReasonToggle
                                    );
                                    setRejectionId(item._id);
                                  }}
                                />
                              )}
                              {(item.moderationStatus === "PENDING" ||
                                item.moderationStatus === "REJECTED") && (
                                <img
                                  className="image_gallery"
                                  alt="tick"
                                  src={TickIcon}
                                  onClick={() =>
                                    handleApproveGalleryModeration(item._id)
                                  }
                                />
                              )}
                            </div>
                          )}
                      </div>
                    </Col>
                  ))
                ) : (
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                    N/A
                  </Col>
                )}
              </Row>

              {usertype &&
                (usertype === "EU Tours Admin" ||
                usertype === "Admin") &&
                toursDetails &&
                toursDetails.moderateImage &&
                toursDetails.moderateImage.gallery &&
                toursDetails.moderateImage.gallery.images &&
                toursDetails.moderateImage.gallery.images.length > 0 && (
                  <div className="d-flex justify-content-center justify-content-between position-relative mt-3">
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.experiencePersonalInfo.rejectAllLabel",
                        "Reject All"
                      )}
                      customClass={"btn-outline-dark bg-none btnthemeColor"}
                      customClick={() => {
                        setRejectImage(true);
                        setRejectionReasonToggle(!rejectionReasonToggle);
                        setRejectionType("All");
                        setRejectionId(
                          toursDetails &&
                            toursDetails.moderateImage &&
                            toursDetails.moderateImage.gallery &&
                            toursDetails.moderateImage.gallery.groupId
                        );
                      }}
                    />
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.experiencePersonalInfo.acceptAllLabel",
                        "Accept All Images"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() =>
                        handleApproveGalleryModeration(
                          toursDetails &&
                            toursDetails.moderateImage &&
                            toursDetails.moderateImage.gallery &&
                            toursDetails.moderateImage.gallery.groupId,
                          "All"
                        )
                      }
                    />
                  </div>
                )}
              <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-5">
                {usertype && (usertype === "EU Tours Admin" || usertype === "Admin") && (
                  <CustomButton
                    customType={"button"}
                    name={_.get(
                      elements,
                      "euToursElement.experiencePersonalInfo.backLabel",
                      "Back"
                    )}
                    customClass={"btn-outline-dark bg-none btnthemeColor"}
                    customClick={() => handleGoBack()}
                  />
                )}
                {usertype &&
                  (usertype === "EU Tours Admin" ||
                  usertype === "Admin")&&
                  toursDetails &&
                  (toursDetails.moderationStatus === "PENDING" ||
                    toursDetails.moderationStatus === "APPROVED") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.experiencePersonalInfo.rejectLabel",
                        "Reject"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() =>
                        setRejectionReasonToggle(!rejectionReasonToggle)
                      }
                    />
                  )}
                {usertype &&
                  (usertype === "EU Tours Admin" ||
                  usertype === "Admin") &&
                  toursDetails &&
                  (toursDetails.moderationStatus === "PENDING" ||
                    toursDetails.moderationStatus === "REJECTED") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.experiencePersonalInfo.approveLabel",
                        "Approve"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() => handleApprove()}
                    />
                  )}
              </div>
            </CardBody>
          </Card>
        </Form>
        <Modal isOpen={rejectionReasonToggle} backdrop={true} centered={true}>
          <ModalHeader
            toggle={() => {
              setRejectionReasonToggle(!rejectionReasonToggle);
              setRejectionReason("");
            }}
          >
            {_.get(
              elements,
              "euToursElement.experiencePersonalInfo.rejectionReasonLabel",
              "Rejection Reason"
            )}
          </ModalHeader>
          <ModalBody>
            <InputText
              inputType={"textarea"}
              inputName={"rejectionReason"}
              customValue={rejectionReason}
              customOnChange={(e) => setRejectionReason(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            {rejectImage === false ? (
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "euToursElement.experiencePersonalInfo.rejectLabel",
                  "Reject"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                customClick={(e) => handleReject(e)}
              />
            ) : (
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "euToursElement.experiencePersonalInfo.rejectLabel",
                  "Reject"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                customClick={(e) => handleRejectGalleryModeration(e)}
              />
            )}
          </ModalFooter>
        </Modal>
        <Modal size="xl" centered isOpen={previewGalleryImage}>
          <ModalHeader toggle={handlePreviewGalleryImages}></ModalHeader>
          <ModalBody>
            <div className="slider">
              <Slider {...settings}>
                {imageGalleryDetails &&
                  imageGalleryDetails.map((item) => (
                    <div>
                      <img
                        src={`${config.imageBaseUrl}/${item.srcPath}`}
                        alt=""
                        className="w-100 preview_InnerImage"
                      />
                    </div>
                  ))}
              </Slider>
            </div>
          </ModalBody>
        </Modal>
        <Modal size="m" centered isOpen={previewImage}>
          <ModalHeader toggle={handlePreviewImages} className="dotted_Heading">
            {imageDetail &&
              imageDetail.srcPath.slice(
                imageDetail.srcPath.lastIndexOf("/") + 1
              )}
          </ModalHeader>
          <ModalBody>
            <div>
              <>
                <img
                  src={`${config.imageBaseUrl}/${imageDetail &&
                    imageDetail.srcPath}`}
                  className="w-100"
                />
                {console.log("name", imageDetail)}
              </>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
}
